import { render, staticRenderFns } from "./ReferenciaDeColoresHistorial.vue?vue&type=template&id=b119d4e6"
import script from "./ReferenciaDeColoresHistorial.vue?vue&type=script&lang=js"
export * from "./ReferenciaDeColoresHistorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports